export default {"src":"/_next/static/media/podcaster-levels-info.80f00d59.svg","height":48,"width":628};